module.exports = __webpack_public_path__ + "resource/img/zfb_pay.8d94fc25.jpg";